<script setup>
import { computed, ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert as wgptUseAlert } from 'dashboard/composables/wgpt';
import { useAlert } from 'dashboard/composables';

import Dialog from 'next/dialog/Dialog.vue';

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const bot = ref({});
const workflow = ref({});
const dialogRef = ref(null);
const uiFlags = getters['wgptBotWorkflows/getUIFlags'];

const description = computed(() => {
  return `${t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.DELETE.CONFIRM.MESSAGE')} ${workflow.value.name}?`;
});

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('wgptBotWorkflows/delete', {
      botId: bot.value.id,
      id: workflow.value.id,
    });

    useAlert(t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.DELETE.API.SUCCESS_MESSAGE'));
    dialogRef.value?.close();
  } catch (error) {
    wgptUseAlert(t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.DELETE.API.ERROR_MESSAGE'));
  }
};

const open = (selectedBot, selectedWorkflow) => {
  bot.value = selectedBot;
  workflow.value = selectedWorkflow;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.DELETE.CONFIRM.TITLE')"
    :description="description"
    :confirm-button-label="
      t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.DELETE.CONFIRM.YES')
    "
    :cancel-button-label="t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.DELETE.CONFIRM.NO')"
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
